import { useGlobal } from "reactn";
import { useLayoutEffect } from "react";
import { useLocation, Link, NavLink } from "react-router-dom";
import variables from "stylesheets/variables.module.scss";
import classnames from "classnames";
import { MediaQuery } from "@outplayed/responsive";
import SearchBar from "components/SearchBar/SearchBar";
import { ReactComponent as Logo } from "svg/pbs-logo.svg";
import { ReactComponent as Menu } from "svg/menu.svg";
import { ReactComponent as NewTag } from "svg/new-tag.svg";
import { Icon } from "@ugitgud/legos/ui/icon/Icon";
import { SvgMiscDownloadFill } from "@ugitgud/legos/ui/icon/SVG/MiscDownloadFill";
import { SvgNavSettings } from "@ugitgud/legos/ui/icon/SVG/NavSettings";
import { amplitudeLog } from "lib/general-helpers";
import { ReactComponent as SearchIcon } from "svg/search-icon.svg";
//import { ReactComponent as World } from "svg/world-logo.svg";

const Masthead = () => {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useGlobal("mobileMenuOpen");
  const isHome = location.pathname === "/";
  const [worldsPromo, setWorldsPromo] = useGlobal("worldsPromo");
  useLayoutEffect(() => {
    document.documentElement.style.setProperty("--masthead-height", variables.mastheadHeight);
    return () => document.documentElement.style.removeProperty("--masthead-height");
  }, []);

  const mastheadClassNames = classnames({
    home: isHome,
    "menu-open": menuOpen,
  });

  return (
    <div id="masthead" className={mastheadClassNames}>
      <div className="masthead_left">
        <MediaQuery min="MOBILE_SMALL" max="MOBILE_LARGE">
          <div className="menu-button" onClick={() => setMenuOpen(!menuOpen)}>
            <Menu className="menu-icon" />
          </div>
        </MediaQuery>
        <Link className="masthead_logo" to="/" aria-label="Home">
          <Logo />
        </Link>
        <MediaQuery min="TABLET" max="DESKTOP_LARGE">
          <div className="masthead_links">
            <NavLink
              className="masthead_link"
              to={"/champions"}
              isActive={(match, location) => {
                return location.pathname.startsWith("/champion");
              }}
            >
              Champions
            </NavLink>
            <NavLink
              className="masthead_link"
              to={"/pros"}
              isActive={(match, location) => {
                return location.pathname.startsWith("/pro");
              }}
            >
              Pros
            </NavLink>
            <NavLink className="masthead_link" to={"/top-picks"}>
              <span>Top 20 Picks</span>
            </NavLink>
            {worldsPromo && (
              <NavLink className="masthead_link" to={"/world"}>
                <img className="world-logo" src={require("images/worlds-logo.png").default} alt="world-logo" />
                <span>BOOTCAMP</span>
                <NewTag className="new-tag" />
              </NavLink>
            )}
          </div>
        </MediaQuery>
      </div>
      <div className="masthead_center">{!isHome && <SearchBar isMasthead autoFocus />}</div>
      <MediaQuery min="TABLET" max="DESKTOP_LARGE">
        <div className="masthead_right">
          <Link
            className="masthead_icon"
            to="/settings/trashcan"
            onClick={() => amplitudeLog("click-settings")}
            aria-label="Settings"
          >
            <Icon icon={<SvgNavSettings />} className="w-[18px] color-white" />
          </Link>
          <a className="ugg-download" href="https://u.gg/app" target="_blank" rel="noopener noreferrer" aria-label="Settings">
            <Icon icon={<SvgMiscDownloadFill />} className="w-[18px] color-white" />
            Download U.GG App
          </a>
        </div>
      </MediaQuery>
    </div>
  );
};

export default Masthead;
